import { useLocation } from 'react-router-dom'

import { Stepper } from './Stepper'
import { CorporateSignupPanel } from '@/panels/corporatesignup/CorporateSignupPanel'
import { LoginHeader } from '@/components/widget-components'
import { ROUTES } from '@/constants/corporateRoutePaths'

export const CorporateSignup = () => {
  const { pathname } = useLocation()

  return (
    <div
      data-testid="container-corporate-signup-page"
      className="flex flex-col md:flex-row gap-4 max-w-[730px] lg:min-w-[730px] mx-auto min-w-full relative"
    >
      <LoginHeader hideBack={pathname === ROUTES.COMPLETE}>
        <Stepper />
      </LoginHeader>
      <div
        data-testid="container-corporate-signup-content"
        className="flex flex-col flex-grow relative"
      >
        <CorporateSignupPanel />
      </div>
    </div>
  )
}

/**
 * Code Improvement Suggestions:
 *
 * 1. Consider adding more semantic HTML elements for better accessibility, such as using <main> or <section> tags.
 * 2. The component lacks error handling or loading states for asynchronous operations that might occur in child components.
 * 3. Consider implementing React.memo to prevent unnecessary re-renders.
 * 4. There's no direct accessibility aria attributes like aria-label that could improve screen reader experience.
 * 5. Adding more descriptive class names would make the styling intention clearer.
 */
